
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ClientDisparosDashboard from './ClientDisparosDashboard';
import { useAuth } from '@/contexts/AuthContext';
import { Users } from 'lucide-react';

const ClientDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Redirecionar automaticamente para Dashboard para usuários cliente
  useEffect(() => {
    if (user?.role === 'cliente' && window.location.pathname === '/client-triggers') {
      navigate('/dashboard');
    }
  }, [user, navigate]);


  return (
    <div className="space-y-6">
      <Tabs defaultValue="overview" className="space-y-6">
        <TabsList className="grid w-full grid-cols-1">
          <TabsTrigger value="overview">Visão Geral</TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-6">
          {/* Container unificado com boas-vindas e dashboard */}
          <Card className="glass-card">
            <CardContent className="p-6">
              <div className="space-y-6">
                {/* Seção de boas-vindas */}
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-montserrat font-bold text-gray-900">
                      Bem-vindo, {user?.name}!
                    </h2>
                    <p className="text-gray-600 mt-1">
                      {user?.client?.legal_name} - {user?.client?.trade_name}
                    </p>
                    <p className="text-sm text-gray-500 mt-2">
                      Último acesso: Hoje às 14:30
                    </p>
                  </div>
                  <div className="w-16 h-16 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-xl flex items-center justify-center">
                    <Users className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Separador visual */}
                <div className="border-t border-gray-200"></div>

                {/* Dashboard de Disparos integrado */}
                <div className="pt-4">
                  <ClientDisparosDashboard />
                </div>
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ClientDashboard;
